import EmptyState from '@/components/linear/empty-state';
import PageToolbar from '@/components/linear/page-toolbar';
import { editCompanyPath, newCompanyPath } from '@/lib/linear-paths';
import { colorFromId } from '@/lib/linear-utils';
import type { Company } from '@/types/company';
import { Link } from '@inertiajs/react';

interface Props {
  companies: Company[];
}

export default function Index({ companies }: Props) {
  return (
    <div className="ln-page">
      <PageToolbar
        title="Workspaces"
        actions={
          <Link href={newCompanyPath()} className="ln-primary-btn" style={{ marginLeft: 0 }}>
            New workspace
          </Link>
        }
        showNew={false}
      />
      <div className="ln-page-scroll">
        {companies.length === 0 ? (
          <EmptyState description="Add a workspace to get started." />
        ) : (
          companies.map((company) => (
            <Link
              key={company.id}
              href={editCompanyPath(company.id)}
              className="ln-row"
              style={{ height: 52 }}
            >
              <span
                style={{
                  width: 16,
                  height: 16,
                  borderRadius: 4,
                  background: colorFromId(company.id),
                  flexShrink: 0,
                }}
              />
              <span className="ln-row-title">{company.name}</span>
              {company.isDefault ? <span className="ln-label">Default</span> : null}
              <span className="ln-row-meta">
                <span className="ln-inbox-sub">
                  {company.githubOrgs?.length
                    ? `Watching ${company.githubOrgs.join(', ')}`
                    : 'No GitHub orgs watched'}
                </span>
              </span>
            </Link>
          ))
        )}
      </div>
    </div>
  );
}
